module.exports = __webpack_public_path__ + "img/marin_web.15fa3812.png";